'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';
import SidenavController from './sidenav.controller.js';
import SidenavSvc from './sidenav.service.js';
import sidenavTemplate from './sidenav.pug';

export default angular.module('directives.sidenav', [])
  .component('sidenav', {
    template: sidenavTemplate,
    controller: SidenavController,
    controllerAs: 'snvm'
  })
  .factory('SidenavSvc', SidenavSvc)
  .name;
